import React from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { triggerMastersRefresh } from "../hooks/useMastersRefresh";

/**
 * Small "Refresh" button for voucher form headers.
 *
 * Clicking it re-pulls master dropdown lists (clients / vendors / items / SAC /
 * projects / categories / bill-types / etc.) WITHOUT touching any header or
 * line-item state you've already entered in the form.
 *
 * Use case: you're entering an invoice, realise the vendor isn't in the list,
 * pop open the Vendors master in another tab, add the vendor, come back to the
 * invoice tab, click Refresh — the new vendor now shows up in the dropdown and
 * everything you already typed is exactly where you left it.
 */
export function RefreshMastersButton({ className = "", label = "Refresh", testid = "refresh-masters-btn" }) {
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={() => {
        triggerMastersRefresh();
        toast.success("Masters refreshed");
      }}
      title="Re-fetch client / vendor / item / SAC dropdowns. Your entered data is preserved."
      className={`bg-white border border-slate-300 hover:bg-slate-50 text-slate-700 px-3 py-2.5 text-xs uppercase tracking-wider font-bold flex items-center gap-1.5 ${className}`}
    >
      <RefreshCw size={13} /> {label}
    </button>
  );
}
